/**
 * Service area type identifiers. Values mirror the trip-service
 * `specificityTier` enum so list rows can pass `data.specificityTier`
 * straight through to the cell renderer / tag without translation.
 *
 * Declared broadest-first, which is also the order the Type dropdown offers
 * them. The trip service resolves overlaps the other way — the most specific
 * tier wins: facility > subRegion > region > territory — so `territory` acts
 * as the bounded catch-all beneath the narrower areas. It still requires the
 * trip location to fall inside its boundary; it is not a wildcard.
 */
export const SERVICE_AREA_TYPE = Object.freeze({
  TERRITORY: 'territory',
  REGION: 'region',
  SUB_REGION: 'subRegion',
  FACILITY: 'facility',
});

/** Human-readable display labels for each SERVICE_AREA_TYPE value. */
export const SERVICE_AREA_TYPE_LABEL = Object.freeze({
  [SERVICE_AREA_TYPE.TERRITORY]: 'Territory',
  [SERVICE_AREA_TYPE.REGION]: 'Region',
  [SERVICE_AREA_TYPE.SUB_REGION]: 'Subregion',
  [SERVICE_AREA_TYPE.FACILITY]: 'Specific Location',
});

/** Inline description shown beneath each type option in the Add Service Area modal dropdown. */
export const SERVICE_AREA_TYPE_DESCRIPTION = Object.freeze({
  [SERVICE_AREA_TYPE.TERRITORY]:
    'Entire state or states, with no county or city narrowing',
  [SERVICE_AREA_TYPE.REGION]:
    'Collection of states, counties, cities, or ZIP codes grouped together',
  [SERVICE_AREA_TYPE.SUB_REGION]:
    'Specific county, city, or ZIP code within a region',
  [SERVICE_AREA_TYPE.FACILITY]: '',
});
